{
  "version": 1,
  "scales": [
    {
      "id": "ph",
      "title": "pH",
      "unit": "",
      "basis": "1:1 water · 8″",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Midwest mineral corn/soy. Too acid AND too alkaline are bad. Green peaks at Tri-State target 6.5–6.6; blue is calcareous lockup.",
      "values": {
        "ridiculous_bad": 4.2,
        "bad_reasonable": 5,
        "deeply_unhealthy": 5.5,
        "edge_healthy": 6,
        "good_reasonable": 6.3,
        "ridiculous_good": 6.6,
        "high_reasonable": 7.3,
        "ridiculous_high": 8.6
      }
    },
    {
      "id": "buffer_ph",
      "title": "Buffer pH (SMP)",
      "unit": "",
      "basis": "SMP buffer",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Higher = less lime needed. ~6.8+ typically no lime; ≤6.0 is a heavy lime program.",
      "values": {
        "ridiculous_bad": 5.5,
        "bad_reasonable": 6,
        "deeply_unhealthy": 6.3,
        "edge_healthy": 6.5,
        "good_reasonable": 6.8,
        "ridiculous_good": 7.2
      }
    },
    {
      "id": "om",
      "title": "Organic matter",
      "unit": "%",
      "basis": "8″",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Mineral-soil OM. 2.2% is a thin but workable Midwest floor; 3.5% is a solid field; 7% is luxury on mineral ground.",
      "values": {
        "ridiculous_bad": 0.4,
        "bad_reasonable": 1,
        "deeply_unhealthy": 1.5,
        "edge_healthy": 2.2,
        "good_reasonable": 3.5,
        "ridiculous_good": 7
      }
    },
    {
      "id": "cec",
      "title": "CEC",
      "unit": "meq/100g",
      "basis": "8″",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Holding capacity. 5 is sand; 11 is the edge of a loam that can feed a crop; 18 is a typical silt-loam; 35 is heavy clay.",
      "values": {
        "ridiculous_bad": 2,
        "bad_reasonable": 5,
        "deeply_unhealthy": 8,
        "edge_healthy": 11,
        "good_reasonable": 18,
        "ridiculous_good": 35
      }
    },
    {
      "id": "p",
      "title": "Phosphorus (P)",
      "unit": "ppm",
      "basis": "stored 8″ · Mehlich-3 · ppm (platform basis)",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Tri-State Bulletin 974 (OH/IN/MI), corn/soy mineral, M3 @ 8″. Critical 20 ppm. 12 is a clear deficiency; 40 is comfortably sufficient; 90 is luxury (environmental, not crop, risk).",
      "values": {
        "ridiculous_bad": 2,
        "bad_reasonable": 8,
        "deeply_unhealthy": 12,
        "edge_healthy": 20,
        "good_reasonable": 40,
        "ridiculous_good": 90
      }
    },
    {
      "id": "k",
      "title": "Potassium (K)",
      "unit": "ppm",
      "basis": "stored 8″ · Mehlich-3 · ppm (platform basis)",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Tri-State Bulletin 974 (OH/IN/MI), corn/soy mineral, M3 @ 8″. Critical 120 ppm on CEC>5 (the common case); 100 on sand. 90 is a real shortage; 170 is a well-built soil; 320 is luxury.",
      "values": {
        "ridiculous_bad": 40,
        "bad_reasonable": 70,
        "deeply_unhealthy": 90,
        "edge_healthy": 120,
        "good_reasonable": 170,
        "ridiculous_good": 320
      }
    },
    {
      "id": "s",
      "title": "Sulfur (S)",
      "unit": "ppm",
      "basis": "stored 8″ · Mehlich-3 · ppm (platform basis)",
      "shape": "sequential",
      "direction": "higher",
      "notes": "M3-S is a weak extractor; 12 ppm is a common sufficiency floor for corn/soy. 50 is luxury.",
      "values": {
        "ridiculous_bad": 2,
        "bad_reasonable": 5,
        "deeply_unhealthy": 8,
        "edge_healthy": 12,
        "good_reasonable": 20,
        "ridiculous_good": 50
      }
    },
    {
      "id": "ca",
      "title": "Calcium (Ca)",
      "unit": "ppm",
      "basis": "stored 8″ · Mehlich-3 · ppm (platform basis)",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Albrecht / BCSR mid-range (platform DEFAULT_ALBRECHT_TARGETS 65/10/3). ~1950 ppm is 65% of CEC 15. Below 1000 is a real Ca shortage on mineral ground; 4500 is a calcareous soil.",
      "values": {
        "ridiculous_bad": 200,
        "bad_reasonable": 600,
        "deeply_unhealthy": 1000,
        "edge_healthy": 1400,
        "good_reasonable": 2000,
        "ridiculous_good": 4500
      }
    },
    {
      "id": "mg",
      "title": "Magnesium (Mg)",
      "unit": "ppm",
      "basis": "stored 8″ · Mehlich-3 · ppm (platform basis)",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Albrecht / BCSR mid-range (platform DEFAULT_ALBRECHT_TARGETS 65/10/3). ~180–250 ppm is 10–12% of CEC 15. Too low AND too high (tight soils) are bad — blue is excess Mg.",
      "values": {
        "ridiculous_bad": 25,
        "bad_reasonable": 50,
        "deeply_unhealthy": 80,
        "edge_healthy": 120,
        "good_reasonable": 180,
        "ridiculous_good": 250,
        "high_reasonable": 400,
        "ridiculous_high": 800
      }
    },
    {
      "id": "zn",
      "title": "Zinc (Zn)",
      "unit": "ppm",
      "basis": "stored 8″ · Mehlich-3 · ppm (platform basis)",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "M3-Zn. 1.2 ppm is a common corn sufficiency floor. Toxicity is rare until high teens; 40 ppm is ridiculous.",
      "values": {
        "ridiculous_bad": 0.2,
        "bad_reasonable": 0.5,
        "deeply_unhealthy": 0.8,
        "edge_healthy": 1.2,
        "good_reasonable": 2.5,
        "ridiculous_good": 8,
        "high_reasonable": 15,
        "ridiculous_high": 40
      }
    },
    {
      "id": "b",
      "title": "Boron (B)",
      "unit": "ppm",
      "basis": "stored 8″ · Mehlich-3 · ppm (platform basis)",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Narrow window. 0.5 ppm is the usual sufficiency edge; >2.5 starts toxicity talk; 5 ppm is a crop-killing slug.",
      "values": {
        "ridiculous_bad": 0.15,
        "bad_reasonable": 0.3,
        "deeply_unhealthy": 0.4,
        "edge_healthy": 0.5,
        "good_reasonable": 1,
        "ridiculous_good": 1.8,
        "high_reasonable": 2.5,
        "ridiculous_high": 5
      }
    },
    {
      "id": "mn",
      "title": "Manganese (Mn)",
      "unit": "ppm",
      "basis": "stored 8″ · Mehlich-3 · ppm (platform basis)",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Deficiency on high-pH soils (~8 ppm floor); toxicity on acid soils (80+). 200 ppm is ridiculous.",
      "values": {
        "ridiculous_bad": 1,
        "bad_reasonable": 4,
        "deeply_unhealthy": 6,
        "edge_healthy": 8,
        "good_reasonable": 20,
        "ridiculous_good": 40,
        "high_reasonable": 80,
        "ridiculous_high": 200
      }
    },
    {
      "id": "k_sat",
      "title": "K saturation",
      "unit": "%",
      "basis": "Albrecht / BCSR mid-range (platform DEFAULT_ALBRECHT_TARGETS 65/10/3)",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Albrecht K% of CEC. Platform default 3%. Below 2.2% is short; above 7% antagonizes Mg.",
      "values": {
        "ridiculous_bad": 0.6,
        "bad_reasonable": 1.2,
        "deeply_unhealthy": 1.8,
        "edge_healthy": 2.2,
        "good_reasonable": 3,
        "ridiculous_good": 4.5,
        "high_reasonable": 7,
        "ridiculous_high": 12
      }
    },
    {
      "id": "ca_sat",
      "title": "Ca saturation",
      "unit": "%",
      "basis": "Albrecht / BCSR mid-range (platform DEFAULT_ALBRECHT_TARGETS 65/10/3)",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Albrecht Ca% of CEC. Target 65%. Below 58% is short; above 80% is calcareous / Mg-starved.",
      "values": {
        "ridiculous_bad": 25,
        "bad_reasonable": 40,
        "deeply_unhealthy": 50,
        "edge_healthy": 58,
        "good_reasonable": 65,
        "ridiculous_good": 72,
        "high_reasonable": 80,
        "ridiculous_high": 92
      }
    },
    {
      "id": "mg_sat",
      "title": "Mg saturation",
      "unit": "%",
      "basis": "Albrecht / BCSR mid-range (platform DEFAULT_ALBRECHT_TARGETS 65/10/3)",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Albrecht Mg% of CEC. Target 10–13%. High Mg (18%+) is the tight-soil problem this platform already treats.",
      "values": {
        "ridiculous_bad": 3,
        "bad_reasonable": 5,
        "deeply_unhealthy": 7,
        "edge_healthy": 8,
        "good_reasonable": 10,
        "ridiculous_good": 13,
        "high_reasonable": 18,
        "ridiculous_high": 28
      }
    },
    {
      "id": "h_sat",
      "title": "H saturation",
      "unit": "%",
      "basis": "exchangeable acidity",
      "shape": "sequential",
      "direction": "lower",
      "notes": "Exchangeable acidity. Lower is better. 20% is the edge of a lime conversation; 70% is a wreck.",
      "values": {
        "ridiculous_bad": 70,
        "bad_reasonable": 45,
        "deeply_unhealthy": 30,
        "edge_healthy": 20,
        "good_reasonable": 12,
        "ridiculous_good": 5
      }
    },
    {
      "id": "na_sat",
      "title": "Na saturation",
      "unit": "%",
      "basis": "ESP",
      "shape": "sequential",
      "direction": "lower",
      "notes": "Exchangeable sodium. <1% is clean; 6% is the edge of sodic behavior; 20% is a sodic soil.",
      "values": {
        "ridiculous_bad": 20,
        "bad_reasonable": 10,
        "deeply_unhealthy": 6,
        "edge_healthy": 3,
        "good_reasonable": 1,
        "ridiculous_good": 0.3
      }
    },
    {
      "id": "base_sat",
      "title": "Base saturation",
      "unit": "%",
      "basis": "Ca+Mg+K+Na / CEC",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Sum of bases. 75% is a workable mineral soil; 98% is fully base-saturated.",
      "values": {
        "ridiculous_bad": 30,
        "bad_reasonable": 50,
        "deeply_unhealthy": 65,
        "edge_healthy": 75,
        "good_reasonable": 85,
        "ridiculous_good": 98
      }
    },
    {
      "id": "haney_shc",
      "title": "Haney soil health score",
      "unit": "",
      "basis": "Haney SHC",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Haney Soil Health Calculation. ~7 is the common “something is alive” floor; 20 is a healthy biological soil; 40 is outstanding.",
      "values": {
        "ridiculous_bad": 1,
        "bad_reasonable": 4,
        "deeply_unhealthy": 7,
        "edge_healthy": 10,
        "good_reasonable": 20,
        "ridiculous_good": 40
      }
    },
    {
      "id": "haney_co2c",
      "title": "Soil respiration (CO₂-C)",
      "unit": "ppm",
      "basis": "24-hr CO₂-C",
      "shape": "sequential",
      "direction": "higher",
      "notes": "1-day burst. <50 is biologically quiet; 150 is active; 400 is a compost-like burst.",
      "values": {
        "ridiculous_bad": 10,
        "bad_reasonable": 30,
        "deeply_unhealthy": 50,
        "edge_healthy": 70,
        "good_reasonable": 150,
        "ridiculous_good": 400
      }
    },
    {
      "id": "haney_weoc",
      "title": "WEOC",
      "unit": "ppm",
      "basis": "H3A",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Water-extractable organic C. 200 is a healthy floor; 600 is rich.",
      "values": {
        "ridiculous_bad": 50,
        "bad_reasonable": 100,
        "deeply_unhealthy": 140,
        "edge_healthy": 200,
        "good_reasonable": 300,
        "ridiculous_good": 600
      }
    },
    {
      "id": "haney_weon",
      "title": "WEON",
      "unit": "ppm",
      "basis": "H3A",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Water-extractable organic N. 40 is a healthy floor.",
      "values": {
        "ridiculous_bad": 8,
        "bad_reasonable": 15,
        "deeply_unhealthy": 22,
        "edge_healthy": 30,
        "good_reasonable": 50,
        "ridiculous_good": 120
      }
    },
    {
      "id": "haney_cn",
      "title": "WEOC:WEON",
      "unit": "",
      "basis": "H3A ratio",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Organic C:N. ~10 is the biological sweet spot; <8 burns N; >20 is wide and slow.",
      "values": {
        "ridiculous_bad": 4,
        "bad_reasonable": 6,
        "deeply_unhealthy": 7,
        "edge_healthy": 8,
        "good_reasonable": 9,
        "ridiculous_good": 11,
        "high_reasonable": 18,
        "ridiculous_high": 35
      }
    },
    {
      "id": "haney_inorg_n",
      "title": "Haney inorganic N",
      "unit": "ppm",
      "basis": "H3A",
      "shape": "sequential",
      "direction": "higher",
      "notes": "H3A inorganic N. 25 ppm is a reasonable in-season pool; 80 is a heavy residual.",
      "values": {
        "ridiculous_bad": 2,
        "bad_reasonable": 8,
        "deeply_unhealthy": 15,
        "edge_healthy": 25,
        "good_reasonable": 40,
        "ridiculous_good": 80
      }
    },
    {
      "id": "haney_inorg_p",
      "title": "Haney inorganic P",
      "unit": "ppm",
      "basis": "H3A",
      "shape": "sequential",
      "direction": "higher",
      "notes": "H3A inorganic P — not interchangeable with M3-P, but the same “shape” of sufficiency.",
      "values": {
        "ridiculous_bad": 2,
        "bad_reasonable": 8,
        "deeply_unhealthy": 15,
        "edge_healthy": 25,
        "good_reasonable": 40,
        "ridiculous_good": 90
      }
    },
    {
      "id": "haney_total_p",
      "title": "Haney total P",
      "unit": "ppm",
      "basis": "H3A",
      "shape": "sequential",
      "direction": "higher",
      "notes": "H3A total P (inorganic + organic).",
      "values": {
        "ridiculous_bad": 5,
        "bad_reasonable": 15,
        "deeply_unhealthy": 25,
        "edge_healthy": 40,
        "good_reasonable": 70,
        "ridiculous_good": 150
      }
    },
    {
      "id": "haney_org_p",
      "title": "Haney organic P",
      "unit": "ppm",
      "basis": "H3A",
      "shape": "sequential",
      "direction": "higher",
      "notes": "H3A organic P pool.",
      "values": {
        "ridiculous_bad": 2,
        "bad_reasonable": 8,
        "deeply_unhealthy": 15,
        "edge_healthy": 25,
        "good_reasonable": 40,
        "ridiculous_good": 80
      }
    },
    {
      "id": "haney_k",
      "title": "Haney K (H3A)",
      "unit": "ppm",
      "basis": "H3A",
      "shape": "sequential",
      "direction": "higher",
      "notes": "H3A potassium. Same shape as M3-K sufficiency, different extractor.",
      "values": {
        "ridiculous_bad": 40,
        "bad_reasonable": 70,
        "deeply_unhealthy": 90,
        "edge_healthy": 120,
        "good_reasonable": 180,
        "ridiculous_good": 350
      }
    },
    {
      "id": "haney_mac",
      "title": "Microbially active C",
      "unit": "%",
      "basis": "Haney MAC",
      "shape": "sequential",
      "direction": "higher",
      "notes": "% of organic C that respired. 50% is a healthy share; 95% is fully active.",
      "values": {
        "ridiculous_bad": 15,
        "bad_reasonable": 30,
        "deeply_unhealthy": 40,
        "edge_healthy": 50,
        "good_reasonable": 70,
        "ridiculous_good": 95
      }
    },
    {
      "id": "haney_avail_n",
      "title": "Haney available N",
      "unit": "lb/ac",
      "basis": "H3A",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Available N credit. 80 lb is a solid in-season pool; 220 is a manure-level residual.",
      "values": {
        "ridiculous_bad": 10,
        "bad_reasonable": 30,
        "deeply_unhealthy": 50,
        "edge_healthy": 80,
        "good_reasonable": 120,
        "ridiculous_good": 220
      }
    },
    {
      "id": "haney_avail_p",
      "title": "Haney available P",
      "unit": "lb/ac",
      "basis": "H3A",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Available P credit.",
      "values": {
        "ridiculous_bad": 10,
        "bad_reasonable": 25,
        "deeply_unhealthy": 40,
        "edge_healthy": 60,
        "good_reasonable": 100,
        "ridiculous_good": 200
      }
    },
    {
      "id": "haney_avail_k",
      "title": "Haney available K",
      "unit": "lb/ac",
      "basis": "H3A",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Available K credit.",
      "values": {
        "ridiculous_bad": 40,
        "bad_reasonable": 80,
        "deeply_unhealthy": 120,
        "edge_healthy": 180,
        "good_reasonable": 280,
        "ridiculous_good": 500
      }
    },
    {
      "id": "fertility_index",
      "title": "Fertility Index",
      "unit": "",
      "basis": "OM 0.6 / P 0.2 / K 0.2 · −10..+10, 0=critical",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Platform fertility index. 0 is the critical (edge of healthy); +4 is comfortably sufficient; ±10 are the authored extremes.",
      "values": {
        "ridiculous_bad": -10,
        "bad_reasonable": -6,
        "deeply_unhealthy": -3,
        "edge_healthy": 0,
        "good_reasonable": 4,
        "ridiculous_good": 10
      }
    },
    {
      "id": "percentile",
      "title": "Percentile",
      "unit": "",
      "basis": "0–100 display twin",
      "shape": "sequential",
      "direction": "from_layer",
      "notes": "Generic 0–100 percentile. Direction follows the layer (a heat-days percentile is lower-better).",
      "values": {
        "ridiculous_bad": 5,
        "bad_reasonable": 15,
        "deeply_unhealthy": 30,
        "edge_healthy": 50,
        "good_reasonable": 70,
        "ridiculous_good": 95
      }
    },
    {
      "id": "percent_0_100",
      "title": "Percent",
      "unit": "%",
      "basis": "0–100",
      "shape": "sequential",
      "direction": "from_layer",
      "notes": "Generic 0–100 percent (cover, probability, composition). Direction follows the layer.",
      "values": {
        "ridiculous_bad": 0,
        "bad_reasonable": 10,
        "deeply_unhealthy": 25,
        "edge_healthy": 40,
        "good_reasonable": 70,
        "ridiculous_good": 100
      }
    },
    {
      "id": "fert_lime",
      "title": "Lime rec",
      "unit": "t/ac",
      "basis": "buildup to pH 6.5, capped 4 t/ac",
      "shape": "sequential",
      "direction": "lower",
      "notes": "More lime = more acid = worse. 0 is green (no need); 4 t/ac is the per-application cap / ridiculous need.",
      "values": {
        "ridiculous_bad": 4,
        "bad_reasonable": 3,
        "deeply_unhealthy": 2,
        "edge_healthy": 1,
        "good_reasonable": 0.5,
        "ridiculous_good": 0
      }
    },
    {
      "id": "fert_p2o5",
      "title": "P₂O₅ rec",
      "unit": "lbs/ac",
      "basis": "Tri-State buildup 15 lb per ppm below 20",
      "shape": "sequential",
      "direction": "lower",
      "notes": "More product = more deficient. 0 is green; ~180 lb is a deep buildup; 320 is a ridiculous single-shot.",
      "values": {
        "ridiculous_bad": 320,
        "bad_reasonable": 200,
        "deeply_unhealthy": 120,
        "edge_healthy": 60,
        "good_reasonable": 30,
        "ridiculous_good": 0
      }
    },
    {
      "id": "fert_k2o",
      "title": "K₂O rec",
      "unit": "lbs/ac",
      "basis": "Tri-State buildup 8 lb per ppm below CEC-tiered critical",
      "shape": "sequential",
      "direction": "lower",
      "notes": "More product = more deficient. 0 is green; 420 is a ridiculous single-shot on a K-fixing soil.",
      "values": {
        "ridiculous_bad": 420,
        "bad_reasonable": 260,
        "deeply_unhealthy": 160,
        "edge_healthy": 80,
        "good_reasonable": 40,
        "ridiculous_good": 0
      }
    },
    {
      "id": "fert_mg",
      "title": "Mg rec",
      "unit": "lbs/ac",
      "basis": "BCSR Mg correction",
      "shape": "sequential",
      "direction": "lower",
      "notes": "Cation-balance Mg addition. 0 is green; 250 is a heavy Mg program.",
      "values": {
        "ridiculous_bad": 250,
        "bad_reasonable": 150,
        "deeply_unhealthy": 80,
        "edge_healthy": 40,
        "good_reasonable": 20,
        "ridiculous_good": 0
      }
    },
    {
      "id": "spread_rate",
      "title": "Product rate",
      "unit": "lbs/ac",
      "basis": "spread product",
      "shape": "sequential",
      "direction": "lower",
      "notes": "Spread product (MAP, potash, lime tons converted to product). More product marks a more deficient spot.",
      "values": {
        "ridiculous_bad": 500,
        "bad_reasonable": 320,
        "deeply_unhealthy": 200,
        "edge_healthy": 100,
        "good_reasonable": 40,
        "ridiculous_good": 0
      }
    },
    {
      "id": "yield_corn",
      "title": "Corn yield",
      "unit": "bu/ac",
      "basis": "dry grain",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Midwest corn. 170 is a thin but real crop; 210 is a good modern field; 280 is an outstanding year.",
      "values": {
        "ridiculous_bad": 50,
        "bad_reasonable": 100,
        "deeply_unhealthy": 140,
        "edge_healthy": 170,
        "good_reasonable": 210,
        "ridiculous_good": 280
      }
    },
    {
      "id": "yield_soy",
      "title": "Soybean yield",
      "unit": "bu/ac",
      "basis": "dry grain",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Midwest soy. 50 is a solid crop; 85 is outstanding.",
      "values": {
        "ridiculous_bad": 15,
        "bad_reasonable": 30,
        "deeply_unhealthy": 40,
        "edge_healthy": 50,
        "good_reasonable": 60,
        "ridiculous_good": 85
      }
    },
    {
      "id": "yield_wheat",
      "title": "Wheat yield",
      "unit": "bu/ac",
      "basis": "dry grain",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Soft-red winter wheat, lower Midwest. 70 is a solid crop; 120 is outstanding.",
      "values": {
        "ridiculous_bad": 25,
        "bad_reasonable": 40,
        "deeply_unhealthy": 55,
        "edge_healthy": 70,
        "good_reasonable": 90,
        "ridiculous_good": 120
      }
    },
    {
      "id": "productivity_index",
      "title": "Productivity Index (corn-eq)",
      "unit": "bu/ac",
      "basis": "NDVI-simulated corn-equivalent",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Same shape as corn yield — the index is authored in corn-equivalent bu/ac.",
      "values": {
        "ridiculous_bad": 50,
        "bad_reasonable": 100,
        "deeply_unhealthy": 140,
        "edge_healthy": 170,
        "good_reasonable": 210,
        "ridiculous_good": 280
      }
    },
    {
      "id": "ndvi",
      "title": "NDVI",
      "unit": "",
      "basis": "0–1 greenness",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Canopy greenness. 0.40 is a thin canopy; 0.62 is a healthy in-season crop; 0.88 is a ridiculous peak.",
      "values": {
        "ridiculous_bad": 0.08,
        "bad_reasonable": 0.18,
        "deeply_unhealthy": 0.28,
        "edge_healthy": 0.4,
        "good_reasonable": 0.62,
        "ridiculous_good": 0.88
      }
    },
    {
      "id": "zscore",
      "title": "Z-score",
      "unit": "",
      "basis": "standard deviations vs history",
      "shape": "sequential",
      "direction": "from_layer",
      "notes": "Standardized anomaly. Direction follows the layer (NDVI z higher-is-better; heat-days z lower-is-better).",
      "values": {
        "ridiculous_bad": -2.5,
        "bad_reasonable": -1.5,
        "deeply_unhealthy": -0.8,
        "edge_healthy": 0,
        "good_reasonable": 0.8,
        "ridiculous_good": 2.5
      }
    },
    {
      "id": "precip_mm",
      "title": "Precipitation",
      "unit": "mm",
      "basis": "growing-season / window total",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Midwest growing-season rain. ~500–600 mm is a good year; drought AND flood are bad — blue is too wet.",
      "values": {
        "ridiculous_bad": 150,
        "bad_reasonable": 250,
        "deeply_unhealthy": 320,
        "edge_healthy": 400,
        "good_reasonable": 500,
        "ridiculous_good": 600,
        "high_reasonable": 800,
        "ridiculous_high": 1100
      }
    },
    {
      "id": "precip_in",
      "title": "Precipitation",
      "unit": "in",
      "basis": "growing-season / window total",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Same as precip_mm in inches (~6–24″ typical; 43″ is a flood year).",
      "values": {
        "ridiculous_bad": 6,
        "bad_reasonable": 10,
        "deeply_unhealthy": 13,
        "edge_healthy": 16,
        "good_reasonable": 20,
        "ridiculous_good": 24,
        "high_reasonable": 32,
        "ridiculous_high": 43
      }
    },
    {
      "id": "deficit_mm",
      "title": "Water deficit",
      "unit": "mm",
      "basis": "PET − precip",
      "shape": "sequential",
      "direction": "lower",
      "notes": "Climatic water deficit. 0 is fully supplied; 300 mm is a severe seasonal shortfall.",
      "values": {
        "ridiculous_bad": 300,
        "bad_reasonable": 150,
        "deeply_unhealthy": 80,
        "edge_healthy": 40,
        "good_reasonable": 15,
        "ridiculous_good": 0
      }
    },
    {
      "id": "heat_days",
      "title": "Heat days",
      "unit": "days",
      "basis": "count",
      "shape": "sequential",
      "direction": "lower",
      "notes": "Stress-day count. 0 is green; 40+ is a brutal grain-fill.",
      "values": {
        "ridiculous_bad": 45,
        "bad_reasonable": 25,
        "deeply_unhealthy": 15,
        "edge_healthy": 8,
        "good_reasonable": 3,
        "ridiculous_good": 0
      }
    },
    {
      "id": "freeze_days",
      "title": "Freeze / frost days",
      "unit": "days",
      "basis": "count",
      "shape": "sequential",
      "direction": "lower",
      "notes": "Freeze events in a sensitive window. 0 is green.",
      "values": {
        "ridiculous_bad": 40,
        "bad_reasonable": 20,
        "deeply_unhealthy": 10,
        "edge_healthy": 5,
        "good_reasonable": 2,
        "ridiculous_good": 0
      }
    },
    {
      "id": "dry_spell",
      "title": "Dry spell",
      "unit": "days",
      "basis": "max consecutive dry",
      "shape": "sequential",
      "direction": "lower",
      "notes": "Longest dry spell. 0–5 days is fine; 40 is a drought stretch.",
      "values": {
        "ridiculous_bad": 40,
        "bad_reasonable": 25,
        "deeply_unhealthy": 15,
        "edge_healthy": 8,
        "good_reasonable": 4,
        "ridiculous_good": 0
      }
    },
    {
      "id": "gdd",
      "title": "Growing degree days",
      "unit": "°C-days",
      "basis": "seasonal accumulation",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Corn-season GDD (°C). 2600 is a full season in the central Corn Belt; 3600 is a long hot year.",
      "values": {
        "ridiculous_bad": 1400,
        "bad_reasonable": 1800,
        "deeply_unhealthy": 2200,
        "edge_healthy": 2600,
        "good_reasonable": 3000,
        "ridiculous_good": 3600
      }
    },
    {
      "id": "tmax",
      "title": "Mean max temperature",
      "unit": "°C",
      "basis": "window mean",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Grain-fill max temps. ~28 °C is a productive day; 38 °C is heat-sterile.",
      "values": {
        "ridiculous_bad": 12,
        "bad_reasonable": 18,
        "deeply_unhealthy": 22,
        "edge_healthy": 25,
        "good_reasonable": 27,
        "ridiculous_good": 29,
        "high_reasonable": 34,
        "ridiculous_high": 40
      }
    },
    {
      "id": "slope_pct",
      "title": "Slope",
      "unit": "%",
      "basis": "grade",
      "shape": "sequential",
      "direction": "lower",
      "notes": "Steeper = more erosion / harder farming. 0% is green; 3% is still easy; 25% is ridiculous for row-crop.",
      "values": {
        "ridiculous_bad": 25,
        "bad_reasonable": 12,
        "deeply_unhealthy": 6,
        "edge_healthy": 3,
        "good_reasonable": 1,
        "ridiculous_good": 0
      }
    },
    {
      "id": "slope_deg",
      "title": "Slope",
      "unit": "degrees",
      "basis": "gradient",
      "shape": "sequential",
      "direction": "lower",
      "notes": "Same as slope_pct in degrees (~14° ≈ 25%).",
      "values": {
        "ridiculous_bad": 14,
        "bad_reasonable": 7,
        "deeply_unhealthy": 3.5,
        "edge_healthy": 1.7,
        "good_reasonable": 0.6,
        "ridiculous_good": 0
      }
    },
    {
      "id": "twi",
      "title": "Topographic wetness index",
      "unit": "",
      "basis": "TWI",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Beven-Kirkby wetness. Mid values (≈10–12) are kindly; very low is shed/dry, very high is ponding.",
      "values": {
        "ridiculous_bad": 2,
        "bad_reasonable": 4,
        "deeply_unhealthy": 6,
        "edge_healthy": 8,
        "good_reasonable": 10,
        "ridiculous_good": 12,
        "high_reasonable": 16,
        "ridiculous_high": 22
      }
    },
    {
      "id": "clay",
      "title": "Clay",
      "unit": "%",
      "basis": "SSURGO / texture",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Midwest row-crop texture. ~18–32% clay is a kindly loam; sand AND heavy clay are worse — blue is gumbo.",
      "values": {
        "ridiculous_bad": 4,
        "bad_reasonable": 8,
        "deeply_unhealthy": 12,
        "edge_healthy": 18,
        "good_reasonable": 25,
        "ridiculous_good": 32,
        "high_reasonable": 45,
        "ridiculous_high": 65
      }
    },
    {
      "id": "sand",
      "title": "Sand",
      "unit": "%",
      "basis": "SSURGO / texture",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Too little sand is tight; too much is drought-prone. ~50% is a comfortable loam.",
      "values": {
        "ridiculous_bad": 5,
        "bad_reasonable": 15,
        "deeply_unhealthy": 25,
        "edge_healthy": 35,
        "good_reasonable": 45,
        "ridiculous_good": 55,
        "high_reasonable": 80,
        "ridiculous_high": 95
      }
    },
    {
      "id": "silt",
      "title": "Silt",
      "unit": "%",
      "basis": "SSURGO / texture",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Silt loams are the region’s best mineral soils. Higher (to a point) is better; 75% is a silt-loam peak.",
      "values": {
        "ridiculous_bad": 5,
        "bad_reasonable": 15,
        "deeply_unhealthy": 25,
        "edge_healthy": 40,
        "good_reasonable": 55,
        "ridiculous_good": 75
      }
    },
    {
      "id": "bulk_density",
      "title": "Bulk density",
      "unit": "g/cm³",
      "basis": "SSURGO",
      "shape": "sequential",
      "direction": "lower",
      "notes": "Compaction. 1.15 is a kind tilth; 1.5 is compacted; 1.7 is a hardpan.",
      "values": {
        "ridiculous_bad": 1.7,
        "bad_reasonable": 1.5,
        "deeply_unhealthy": 1.35,
        "edge_healthy": 1.25,
        "good_reasonable": 1.15,
        "ridiculous_good": 1
      }
    },
    {
      "id": "ksat",
      "title": "Ksat",
      "unit": "µm/s",
      "basis": "SSURGO",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Saturated conductivity. <1 is nearly impermeable; 40+ is freely drained.",
      "values": {
        "ridiculous_bad": 0.1,
        "bad_reasonable": 1,
        "deeply_unhealthy": 5,
        "edge_healthy": 15,
        "good_reasonable": 40,
        "ridiculous_good": 150
      }
    },
    {
      "id": "awc",
      "title": "Available water capacity",
      "unit": "cm/cm",
      "basis": "SSURGO",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Water held per cm of soil. 0.13 is a typical loam; 0.25 is outstanding.",
      "values": {
        "ridiculous_bad": 0.04,
        "bad_reasonable": 0.08,
        "deeply_unhealthy": 0.1,
        "edge_healthy": 0.13,
        "good_reasonable": 0.18,
        "ridiculous_good": 0.25
      }
    },
    {
      "id": "ec_saline",
      "title": "EC (salinity)",
      "unit": "dS/m",
      "basis": "saturation extract",
      "shape": "sequential",
      "direction": "lower",
      "notes": "Salinity. <1 is clean; 2 is the edge of sensitive-crop injury; 8 is a saline soil.",
      "values": {
        "ridiculous_bad": 8,
        "bad_reasonable": 4,
        "deeply_unhealthy": 2,
        "edge_healthy": 1,
        "good_reasonable": 0.5,
        "ridiculous_good": 0.2
      }
    },
    {
      "id": "ec_scan",
      "title": "EC scan",
      "unit": "mS/m",
      "basis": "Veris / apparent EC",
      "shape": "sequential",
      "direction": "from_layer",
      "notes": "On-the-go EC is mostly a TEXTURE proxy here, not salinity. Direction follows the catalog; 5–80 mS/m covers typical Midwest scans.",
      "values": {
        "ridiculous_bad": 2,
        "bad_reasonable": 8,
        "deeply_unhealthy": 15,
        "edge_healthy": 25,
        "good_reasonable": 45,
        "ridiculous_good": 80
      }
    },
    {
      "id": "kfactor",
      "title": "K-factor (erodibility)",
      "unit": "",
      "basis": "SSURGO kffact",
      "shape": "sequential",
      "direction": "lower",
      "notes": "USLE K. 0.02 is a stable soil; 0.43 is highly erodible; 0.64 is the textbook ceiling.",
      "values": {
        "ridiculous_bad": 0.64,
        "bad_reasonable": 0.43,
        "deeply_unhealthy": 0.32,
        "edge_healthy": 0.2,
        "good_reasonable": 0.1,
        "ridiculous_good": 0.02
      }
    },
    {
      "id": "kfix",
      "title": "K fixation (gross)",
      "unit": "%",
      "basis": "clay-group × clay %",
      "shape": "sequential",
      "direction": "lower",
      "notes": "Gross first-season K fixed. 0 is a sandy non-fixer (green); 60% is a smectitic clay that swallows K.",
      "values": {
        "ridiculous_bad": 60,
        "bad_reasonable": 40,
        "deeply_unhealthy": 25,
        "edge_healthy": 15,
        "good_reasonable": 8,
        "ridiculous_good": 0
      }
    },
    {
      "id": "cover_prob",
      "title": "Cover-crop probability",
      "unit": "",
      "basis": "0–1",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Detected cover. 0.4 is the edge of a real cover; 1.0 is a sure stand.",
      "values": {
        "ridiculous_bad": 0,
        "bad_reasonable": 0.1,
        "deeply_unhealthy": 0.25,
        "edge_healthy": 0.4,
        "good_reasonable": 0.7,
        "ridiculous_good": 1
      }
    },
    {
      "id": "rotation_div",
      "title": "Rotation diversity",
      "unit": "",
      "basis": "count / index",
      "shape": "sequential",
      "direction": "higher",
      "notes": "More distinct crops is better. 1 is a monoculture; 4 is a diverse rotation.",
      "values": {
        "ridiculous_bad": 0.2,
        "bad_reasonable": 0.5,
        "deeply_unhealthy": 1,
        "edge_healthy": 1.5,
        "good_reasonable": 2.5,
        "ridiculous_good": 4
      }
    },
    {
      "id": "corn_on_corn",
      "title": "Corn-on-corn",
      "unit": "",
      "basis": "0–1 frequency",
      "shape": "sequential",
      "direction": "lower",
      "notes": "Continuous corn. 0 is a real rotation (green); 1 is corn every year.",
      "values": {
        "ridiculous_bad": 1,
        "bad_reasonable": 0.8,
        "deeply_unhealthy": 0.6,
        "edge_healthy": 0.4,
        "good_reasonable": 0.2,
        "ridiculous_good": 0
      }
    },
    {
      "id": "seedrate_corn",
      "title": "Corn seeding rate",
      "unit": "seeds/ac",
      "basis": "as-planted",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Modern corn. ~32–36k is the productive window; too thin AND too thick are worse — blue is a ridiculous crowd.",
      "values": {
        "ridiculous_bad": 18000,
        "bad_reasonable": 24000,
        "deeply_unhealthy": 28000,
        "edge_healthy": 32000,
        "good_reasonable": 34000,
        "ridiculous_good": 36000,
        "high_reasonable": 40000,
        "ridiculous_high": 48000
      }
    },
    {
      "id": "seedrate_soy",
      "title": "Soy seeding rate",
      "unit": "seeds/ac",
      "basis": "as-planted",
      "shape": "bipolar",
      "direction": "higher",
      "notes": "Soy. ~140–160k is a typical drilled stand; 250k is a ridiculous crowd.",
      "values": {
        "ridiculous_bad": 80000,
        "bad_reasonable": 110000,
        "deeply_unhealthy": 130000,
        "edge_healthy": 140000,
        "good_reasonable": 160000,
        "ridiculous_good": 180000,
        "high_reasonable": 200000,
        "ridiculous_high": 250000
      }
    },
    {
      "id": "appl_n",
      "title": "As-applied N",
      "unit": "lb/ac",
      "basis": "machine",
      "shape": "sequential",
      "direction": "from_layer",
      "notes": "Observed N rate. Direction follows the layer when the catalog has one; otherwise higher-is-better as a supply.",
      "values": {
        "ridiculous_bad": 0,
        "bad_reasonable": 40,
        "deeply_unhealthy": 80,
        "edge_healthy": 120,
        "good_reasonable": 180,
        "ridiculous_good": 280
      }
    },
    {
      "id": "till_depth",
      "title": "Tillage depth",
      "unit": "in",
      "basis": "machine",
      "shape": "sequential",
      "direction": "from_layer",
      "notes": "Observed tillage depth. Catalog direction wins; 0 is no-till, 12″ is deep.",
      "values": {
        "ridiculous_bad": 0,
        "bad_reasonable": 2,
        "deeply_unhealthy": 4,
        "edge_healthy": 6,
        "good_reasonable": 8,
        "ridiculous_good": 12
      }
    },
    {
      "id": "ppm_generic",
      "title": "Concentration",
      "unit": "ppm",
      "basis": "unspecified analyte",
      "shape": "sequential",
      "direction": "from_layer",
      "notes": "Fallback when a ppm layer is not a known soil analyte. Direction follows the catalog.",
      "values": {
        "ridiculous_bad": 0,
        "bad_reasonable": 5,
        "deeply_unhealthy": 15,
        "edge_healthy": 30,
        "good_reasonable": 60,
        "ridiculous_good": 150
      }
    },
    {
      "id": "diffusion_p",
      "title": "P diffusion supply",
      "unit": "ppm",
      "basis": "season-total effective P",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Season-total P supply (diffusion model). Same shape as soil-test P, slightly more generous because it is a season integral.",
      "values": {
        "ridiculous_bad": 4,
        "bad_reasonable": 12,
        "deeply_unhealthy": 18,
        "edge_healthy": 28,
        "good_reasonable": 50,
        "ridiculous_good": 110
      }
    },
    {
      "id": "diffusion_k",
      "title": "K diffusion supply",
      "unit": "ppm",
      "basis": "season-total effective K",
      "shape": "sequential",
      "direction": "higher",
      "notes": "Season-total K supply (diffusion model). Same shape as soil-test K.",
      "values": {
        "ridiculous_bad": 50,
        "bad_reasonable": 80,
        "deeply_unhealthy": 110,
        "edge_healthy": 140,
        "good_reasonable": 200,
        "ridiculous_good": 360
      }
    }
  ]
}
